module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "91px",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 90,
      "color": "#4caf50"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cbde8fd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Loading.vue
// module id = 455
// module chunks = 1